import React, { Dispatch, SetStateAction } from 'react';
import { Icon, Modal, Button } from 'ui';
import { FormattedMessage, useIntl } from 'react-intl';

interface ConfirmModalProps {
  setShowModal: Dispatch<SetStateAction<boolean>>;
  showModal: boolean;
  onOk: Function;
  confirmText?: string;
  customConfirmText?: any;
  title?: string | React.ReactNode;
}

const ConfirmModal = ({ setShowModal, showModal, onOk, confirmText, customConfirmText, title }: ConfirmModalProps) => {
  const intl = useIntl();

  const renderConfirmText = () => {
    if (customConfirmText) {
      return customConfirmText;
    }

    return confirmText ? <FormattedMessage id={confirmText} /> : <FormattedMessage id="general.confirm_text" />;
  };

  const renderTitle = () => {
    if (title) {
      return title;
    }

    return intl.formatMessage({ id: 'modal.default_confirm_title' });
  };

  return (
    <Modal
      onCancel={() => setShowModal(false)}
      open={showModal}
      closable={false}
      title={renderTitle()}
      centered
      footer={
        <>
          <Button label={intl.formatMessage({ id: 'general.cancel' })} onClick={() => setShowModal(false)} />
          <Button label={intl.formatMessage({ id: 'general.confirm' })} onClick={onOk} />
        </>
      }
    >
      <h3 className="confirm-title">
        <Icon faBase="fal" icon="exclamation-circle" />
        {renderConfirmText()}
      </h3>
    </Modal>
  );
};

export default ConfirmModal;
